$breakpoints: (xl, lg, md, sm, xs, xxs);

.signet-popover {
  position: relative;
  display: inline-block;
  // line-height: 1;

  .popover-button {
    .popover-text {
      margin-right: 4px;
    }
  }

  .popover-contents {
    display: flex;
    flex-direction: column;
    visibility: hidden;
    opacity: 0;
    left: 0;
    position: absolute;
    list-style: none;
    overflow: hidden;
    white-space: nowrap;
    width: auto;
    overflow-x: auto;
    transform: translateY(-0.25rem);
    background-color: white;
    border-radius: 4px;
    z-index: 10;
    padding: 8px 0;
    transition: all 0.3s ease-in-out;

    .popover-item {
      padding: 8px;

      > * {
        display: inline-block;
      }

      a {
        text-align: left;
        text-decoration: none;
        display: block;
        width: 100%;
        font-weight: normal;
        color: var(--text-primary);
        font-size: 16px;
      }

      a,
      .popover-button {
        width: 100%;
        padding: 0;

        &[display='link'] > * {
          text-align: left;
          text-decoration: none;
          display: block;
          width: 100%;
          font-weight: normal;
          color: var(--text-primary);
          font-size: 16px;
          padding: 0 4px;
          padding: 12px;
        }
      }
    }

    &.align-left {
      left: 0;
      right: auto;
      border-top-left-radius: 0;
    }

    &.align-right {
      right: 0;
      left: auto;
      border-top-right-radius: 0;
    }
  }

  &.show-contents {
    .popover-button {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }

    .contents {
      visibility: visible;
      opacity: 1;
      transform: translateY(0rem);
      box-shadow: 0 3px 5px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.12);
      transition: all 0.3s ease-in-out;
    }

    .popover-contents {
      display: flex;
      flex-direction: column;
    }

    &[display='link'] {
      .popover-contents {
        margin-top: 4px;
      }
    }
  }
}
